import type { IButtonProps } from '@fluentui/react/lib/Button';
import { observer } from 'mobx-react-lite';
import CalendarBar from 'owa-calendar-forms-common/lib/components/CalendarBar';
import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import * as React from 'react';

export interface QuickComposeHeaderProps {
    colorScheme: ColorScheme;
    buttonProps: IButtonProps[];
    className?: string;
}

export default observer(function QuickComposeHeader(props: QuickComposeHeaderProps) {
    const { colorScheme, className, buttonProps } = props;
    return (
        <CalendarBar
            className={className}
            calendarColorScheme={colorScheme}
            buttonProps={buttonProps}
        />
    );
});
